<template>
    <footer class="pandora-footer">
        <input id="menu" type="checkbox" class="pandora-footer-switch" aria-label="Menú de navegación">
        <div class="pandoraContainer" :style="style" aria-label="Menú principal" role="navigation">
            <slot></slot>
        </div>
        <p class="pandora-t-center" aria-label="Derechos de autor">Copyright © 2024 Aportes en Línea. Todos los derechos
            reservados.</p>
    </footer>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    columnSize: {
        type: Number,
        default: 4
    }
});

const style = computed(() => {
    return `grid-template-columns: repeat(${props.columnSize}, 1fr)`
})
</script>

<style>
.s-content {
    box-shadow: none !important;
}

.footer-a-li {
    color: #BBB;
    text-decoration: none;
}

.navfooter {
    justify-content: center;
}

.pandora-footer ul,
.pandora-footer li {
    list-style: none !important;
}

.pandora-footer li a {
    color: #BBB;
    text-decoration: none;
    font-family: sans-serif;
    font-weight: bold;
    font-size: 13px;
}

.navfooter .pandora-footer li,
.navfooter .pandora-footer a {
    color: #BBB;
    text-decoration: none;
}

@media (max-width: 1215px) {

    .pandoraContainer,
    .contenticons {
        display: none !important;
    }

    .no-responsive .pandoraContainer {
        display: grid !important;
    }

    .no-responsive .contenticons {
        display: flex !important;
    }

    .pandora-t-center {
        margin-top: 20px;
    }

    .pandora-footer {
        /* position: absolute; */
        width: 100%;
        padding-top: 3rem;
        background-color: #333;
        position: relative;
        min-height: 23vh;
        margin-top: -20px;
        z-index: 0;
        align-content: center;
    }

    .no-responsive .pandora-footer {
        width: 1200px !important;
    }

    .pandora-footer ul {
        display: flex;
    }
}

@media (min-width: 1215px) {
    .disabledContent {
        display: none;
    }
}

.imgBorder {
    border-radius: 20px;
    border: 1px solid #FFF;
    margin-inline: 5px
}

.contenticons {
    text-align: center;
    margin-top: 20px;
}

.pandora-footer img {
    overflow-clip-margin: content-box;
    overflow: clip;
}

.pandora-t-center {
    text-align: center;
    font-size: 12px;
    margin: 0;
    color: #888;
}

.pandora-footer input,
.pandora-footer select {
    color: #888;
}

.pandora-footer a:hover {
    color: #FFF;
}

.pandoraContainer {
    max-width: 1150px;
    margin: auto;

    justify-items: center;
    display: grid;
    grid-template-rows: 1fr;
}

.pandora-footer-switch {
    display: none;
}

.pandora-footer ul {
    width: 930px;
    /* display: flex; */
    flex-wrap: wrap;
    z-index: 10;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    padding-inline-start: 0;
}
</style>